import { css } from '@emotion/css';

/* XXX should this be attached to the theme somehow? */


export const posterGridStyle = () => css({
	display: 'flex',
	padding: '0 10px',
	maxWidth: '100%',
	flexWrap: 'wrap',
	justifyContent: 'center',
	gap: 48
});




